export class ResponseOptions {
  responseType: "json" | "text";
}
